import React, { useState } from "react";
import Drawer from "../../drawer/Drawer";
import {
  useToggleMediaPlayer,
  useSetCourseMedia,
  useSetCurrentTrack,
} from "../../../context/siteContext";
import { Play } from "../../media/Icons";

import BlockContent from "@sanity/block-content-to-react";

import styles from "./hero.module.css";

const CourseHero = ({
  courseContent = [],
  courseDescription,
  courseType,
  audioTrailer,
  videoTrailer,
  title,
}) => {
  const setMediaPlayerOpen = useToggleMediaPlayer();
  const setCourseMedia = useSetCourseMedia();
  const setCurrentTrack = useSetCurrentTrack();

  const [currentOpenDrawer, setCurrentOpenDrawer] = useState(null);

  const playTrailer = () => {
    const audioCourse = !!audioTrailer;
    const videoCourse = !!videoTrailer;

    if (!audioTrailer && !videoTrailer) return;

    const trailerTrack = {
      title: `Trailer — ${title}`,
      audioUrl: audioCourse ? audioTrailer.asset.url : undefined,
      video: videoCourse ? videoTrailer.asset : undefined,
    };

    setCurrentTrack(trailerTrack);
    setCourseMedia(courseType === "audio" ? "audio" : "video", [trailerTrack]);
    setMediaPlayerOpen(true);
  };

  return (
    <div>
      {courseDescription && (
        <div className="block-content">
          <BlockContent blocks={courseDescription.description} />
        </div>
      )}

      {(audioTrailer || videoTrailer) && (
        <button className={styles.heroTrailerButton} onClick={playTrailer}>
          <Play /> Play Trailer
        </button>
      )}

      {courseContent && courseContent.length > 0 && (
        <div className="course__line-item-content w">
          <ul className="course__line-item-content-list w">
            {courseContent.map((item, index) => {
              const drawerTitle = (
                <div className="f w jcb">
                  <span className="mr1">{index + 1}.</span>
                  <span>{item.title}</span>
                </div>
              );
              return (
                <li className="course__line-item-index w" key={item._key}>
                  <Drawer
                    onClick={() => {
                      setCurrentOpenDrawer(item._key);
                    }}
                    isClosed={currentOpenDrawer !== item._key}
                    title={drawerTitle}
                  >
                    {item.description && (
                      <div className="block-content">
                        <BlockContent blocks={item.description} />
                      </div>
                    )}
                  </Drawer>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CourseHero;
